import styled from 'styled-components';

export const StyledGuardianSection = styled.div`
   display: grid;
   grid-template-columns: 356px 186px 186px;
   grid-column-gap: 36px;
   grid-row-gap: 24px;
   grid-template-rows: auto;
`;
StyledGuardianSection.displayName = 'StyledGuardianSection';

export const StyledEnterDataOnceButton = styled.div`
   margin-top: 26px;
   grid-column: span 2;
`;
StyledEnterDataOnceButton.displayName = 'StyledEnterDataOnceButton';

export const StyledGuardianLastName = styled.div`
   grid-column: span 2;
`;
StyledGuardianLastName.displayName = 'StyledGuardianLastName';
